import moment from 'moment';
import React, { ReactElement } from 'react';
import unlockOfferBagIcon from '../../assets/images/unlock_offer_bag.svg';

type AllOffers = {
  customerCouponId: number;
  mobileNumber: string;
  couponGeneratedTime: string;
  couponCode: string;
  description: string;
  validity: string;
  keyId: string;
  couponType: string;
  regionId: string;
  detailsId: number;
  couponDesc: string;
  validTillDate: string;
};

const OfferCard = ({
  offers,
  onClick,
}: {
  offers: AllOffers[];
  onClick: (offer: AllOffers) => void;
}): ReactElement => {
  const getValidity = (validity: string) => {
    return moment(validity).format('DD MMM YYYY');
  };
  return (
    <div>
      {offers.map((offer, index) => {
        return (
          <div
            key={offer.couponCode}
            onClick={() => onClick(offer)}
            className={`pt-3 px-4 pb-4 mb-4 ${index % 2 === 0
                ? 'rounded-2xl bg-very_light_purle'
                : 'rounded-lg border border-solid border-dusky_blue bg-blue_four'
              }`}>
            <div className="font-bold font-roboto text-lg leading-5 mb-2">
              {offer.description}
            </div>
            <div className="flex justify-between">
              <div>
                <div className="text-xs font-roboto font-bold pt-5 mb-3">
                  Valid till
                </div>
                <div
                  className={`rounded-lg border-solid border-gray-400 w-24 h-10 flex justify-center items-center ${index % 2 === 0 ? 'bg-lightest_gray' : 'bg-very_light_purle'
                    }`}>
                  {getValidity(offer.validity)}
                </div>
              </div>
              <div className="pr-5">
                <img src={unlockOfferBagIcon} />
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default OfferCard;
